import { Paper, Table, TableHead, TableCell, TableBody, TableRow, Accordion, AccordionDetails, AccordionSummary, Typography, Box, Button } from '@mui/material';
import React, { useState } from 'react';
import { resume } from '../helpers/Resume';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Experience = () => {
    const [expandedAccordions, setExpandedAccordions] = useState<number[]>([0]);
    const allExperienceExpanded = expandedAccordions.length === resume.experience.length;

    const updateAccordion = (index: number) => {
        if (expandedAccordions.includes(index)) {
            setExpandedAccordions(
                expandedAccordions.filter((number) => number !== index)
            );
        }
        else {
            setExpandedAccordions([...expandedAccordions, index]);
        }
    }

    const updateAllAccordions = () => {
        if (allExperienceExpanded) {
            setExpandedAccordions([]);
        } else {
            setExpandedAccordions([...Array(resume.experience.length).keys()]);
        }
    }

    return (
        <React.Fragment>
            <Paper sx={{ padding: '1.5em' }} elevation={0.75}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography sx={{ fontWeight: 'bold', fontSize: '2em' }}>Employment</Typography>
                                <Button sx={{ marginLeft: 'auto', fontSize: '0.75em', padding: '1em', height: '3em' }} variant="contained" onClick={updateAllAccordions}>{allExperienceExpanded ? "Collapse" : "Expand"} all</Button>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {resume.experience.map((exp, index) => {
                            return (
                                <TableRow>
                                    <TableCell align="left">
                                        <Accordion key={index} onChange={() => updateAccordion(index)} expanded={expandedAccordions.includes(index)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                            >
                                                <Typography component="span">{exp.company}</Typography>
                                                <Typography sx={{ fontSize: '0.9em', alignSelf: 'center', marginLeft: 'auto', paddingRight: '1em' }}> {exp.dates}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Box sx={{ display: 'flex' }}><Typography sx={{ fontWeight: 'bold', fontSize: '1.2em' }}>{exp.title}</Typography><Typography>&nbsp;-&nbsp;</Typography><Typography sx={{ alignSelf: 'center', fontSize: '1.1em' }}>{exp.location}</Typography></Box>
                                                {exp.responsibilities.map((resp) => {
                                                    return <Box>• {resp}</Box>
                                                })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </Paper>
            <br />
            <Paper sx={{ padding: '1.5em' }} elevation={0.75}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '2em' }}>Education</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="left">
                                {resume.education.map((ed) => {
                                    return (
                                        <React.Fragment>
                                            <Box>{ed.dates}</Box>
                                            <Box sx={{ display: 'flex' }}><Typography sx={{ fontWeight: 'bold' }}>{ed.degree}</Typography><Typography>&nbsp;-&nbsp;{ed.institution}</Typography></Box>
                                            <Box>{ed.gpa} GPA</Box>
                                        </React.Fragment>
                                    )
                                })}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table sx={{ marginTop: '2em' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', fontSize: '2em' }}>Skills and Tech</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="left">
                                <Box sx={{ display: 'flex' }}> <Typography sx={{ fontWeight: 'bold' }}>Languages</Typography><Typography>: {resume.skills.programmingLanguages.join(", ")}</Typography></Box>
                                <Box sx={{ display: 'flex' }}> <Typography sx={{ fontWeight: 'bold' }}>Technology</Typography><Typography>: {resume.skills.software.join(", ")}</Typography></Box>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        </React.Fragment>
    );
}

export default Experience;
